// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babel
//import "babel-polyfill";
// globals App //

require("element-closest/browser");

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

import "trix";
import "@rails/actiontext";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "whatwg-fetch";
import Promise from "promise-polyfill";
if (!window.Promise) {
  window.Promise = Promise;
}
import "jquery-color";

export * from "../home";
export * from "../platin";
export * from "../utils";
export * from "../datatable-initializers";
export * from "../people";
export * from "../help";
export * from "../shortcuts";
export * from "../autocomplete";
export * from "../collapse-panels";
export * from "../document-select";
export * from "../drop-file";
export * from "../explanations";
export * from "../form-validation";
export * from "../inline-editing";
import "../arrow-keys";
export * from "../meeting-series";
export * from "../meetings";
export * from "../environment-restrictions";
export * from "../person-select";
export * from "../table-controls";
export * from "../tabs";
export * from "../tnts";
export * from "../tdbs";
export * from "../planning-version";
export * from "../tunnel-occupation";
import "../tunnel-occupation-compact";
import "../tunnelmonitoring";
import "../graphical_timetable";
import "../train-plot";
import "../rbc-connection-drops";
export * from "../modals";
import "../people-edit";
import "../calendar";
export * from "../forms";
import "../rolling-stock-planning";
import "../rolling-stock-types-planning";
import "../information-element";
import "../syscon";
export * from "../d3utils";
export * from "../rbc";
import "../planning-scenarios";
import "../shift-slots";
import "../probebetrieb";
import "../outage-gantt";
export * from "../locations";
import "../web-requests";
import "../roles-select";
export * from "../missions";
import "../history";
export * from "../photo-booth";
export * from "../staff";
import "../qualifications";
import "../badge-data-dialog";
import "../cockpit";
export * from "../rail_cars";
export * from "../debriefing-info";
import "../planning-calendar";
import "../email-deliveries";
import "../train-export";
import "../trains";
import "../fsa";

import "../css/application";
import "../css/vendor-css";